<script>
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import VehicleMakeTable from "./VehicleFuelTable.svelte";
	import { form, field, combined } from "svelte-forms";
	import { onMount } from "svelte";
	import { navigate } from "svelte-routing";
	import {
		errorMessage,
		loading,
		totalPages,
		loadingStatus,
		vehicleEditData,
	} from "../../../../store/store";
	import client from "../../../../services/client";
	import Loader from "../../../../components/Loader/Loader.svelte";
	import {
		required,
		min,
		max,
		email,
		pattern,
	} from "svelte-forms/validators";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";

	let idFuel = window.location.pathname.split(
		"master-data/vehicle-data/vehicle-fuel/edit/"
	)[1];
	let data = [];
	let carFuelError;
	const carFuel = field("carFuel", $vehicleEditData.name, [required()]);
	const myForm = form(carFuel);

	let load = false;
	const handleSubmit = async () => {
		try {
			load = true;
			loading.set(true);
			const res = await client("/v1/fuel/types", {
				method: "PUT",
				version: "Vehicle",
				data: {
					name: $carFuel.value,
					id: idFuel,
				},
			});

			if (res?.status === 200) {
				navigate("/master-data/vehicle-data/vehicle-fuel");
			} else {
				loading.set(false);
				carFuelError = res.data.message;
			}

			load = false;
			loading.set(false);
		} catch (error) {
			console.log(error);
			load = false;
			carFuelError = error.response.data.message;
			loading.set(false);
		}
	};
</script>

<Row>
	<Col xs={6}>
		<Col xs={12}>
			<div>
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="Vehicle Fuel Data" />
				</Col>
			</div>
		</Col>
		<Col xs={12} class="my-3">
			<div>
				<h5><b>Edit Fuel Type</b></h5>
			</div>
			<div>
				<p>*Mandatory fields</p>
			</div>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="mobile" class="d-block">
						<span>Fuel Type* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomInput
						type="text"
						bind:value={$carFuel.value}
						error={$myForm.hasError("carFuel.required") ||
							carFuelError}
						errorText={$myForm.hasError("carFuel.required")
							? "Fuel type is required"
							: carFuelError
								? carFuelError
								: ""}
					/>
				</Col>
				<Col class="d-flex justify-content-start" xs={6}>
					<div class="mx-4 my-1">
						<Button
							class="themeButton primary px-2"
							block
							disabled={!$myForm.valid || !$carFuel.value}
							on:click={myForm.validate}
							on:click={() => handleSubmit()}
						>
							{#if load}
								<Loader />
							{:else}
								Edit
							{/if}
						</Button>
					</div>
				</Col>
			</Row>
		</Col>
	</Col>
</Row>
